import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("salitre_cookies")) setShow(true);
  }, []);
  const accept = () => { localStorage.setItem("salitre_cookies", "1"); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-[60] border-t border-[#E7E5E4] bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 px-5 py-4 sm:flex-row sm:justify-between">
        <p className="flex items-start gap-2 text-sm text-[#57534E]">
          <Cookie className="mt-0.5 h-4 w-4 shrink-0 text-[#EA580C]" />
          Usamos cookies técnicas necesarias para el funcionamiento del sitio. Consulta nuestra{" "}
          <Link to="/legal/cookies" className="font-semibold text-[#0369A1] underline">Política de Cookies</Link>.
        </p>
        <button data-testid="cookie-accept" onClick={accept} className="shrink-0 rounded-full bg-[#075985] px-6 py-2.5 text-sm font-bold text-white hover:bg-[#0C4A6E]">Aceptar</button>
      </div>
    </div>
  );
}
